module.exports = __webpack_public_path__ + "img/edit-red.21fa33d8.svg";